import { Polly } from '@pollyjs/core';
import FetchAdapter from '@pollyjs/adapter-fetch';
import XHRAdapter from '@pollyjs/adapter-xhr';
import PollyAdapterPersister from './persister.js';

export default class PollyAdapter {
  static init() {
    window.polly_har = {};
    Polly.register(FetchAdapter);
    Polly.register(XHRAdapter);
    PollyAdapter.createPollyInstance();
  }

  static createPollyInstance() {
    window.polly_adapter = new Polly('polly-adapter', {
      adapters: ['fetch', 'xhr'],
      persister: PollyAdapterPersister,
      recordFailedRequests: true
    });
  }

  static stop() {
    return window.polly_adapter.stop();
  }

  static har() {
    return window.polly_har;
  }
}
